



















































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from 'vuex';

import Dropdown from '~/components/partials/Dropdown.vue';
import ChevronRightSolid from "~/components/icons/ChevronRightSolid.vue";
import CheckInput from "~/components/inputs/CheckInput.vue";
import SportsPicker from "~/components/partials/SportsPicker.vue";
import LoaderPlaceholder from "~/components/icons/LoaderPlaceholder.vue";

@Component({
  components:{ LoaderPlaceholder, SportsPicker, CheckInput, ChevronRightSolid, Dropdown },
  computed: {
    ...mapState('explorer', [
      'destinationsMap',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
})
export default class SportsDropdown extends Vue {
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(Array) availableSports: [{title : string, sports : Types.SportItem }];
  @Prop(Number) selectedLength: 0;
  @Prop(String) label: '';
  locale: string;
  isOneChildSelected : boolean = false;

  /* Returns a width for the dropdown based on device's innerWidth */
  get dropdownWidth () {
    if (process.client) {
      return window.innerWidth < 768 ? 'w-screen' : 'w-30';
    }
    return '';
  }
}
